import { Box, styled, useTheme } from "@mui/material"
import clsx from "clsx"

import { deepmerge } from "@mui/utils"
import { ScrollableTab } from "components/ScrollableTab"

// Prevents Error From React does not recognize the following prop on a DOM element.
const TabContentWrapper = styled(Box, {
  shouldForwardProp: (props) =>
    !["indicator", "textColor", "fullWidth", "selectionFollowsFocus"].includes(
      props as string
    ),
})(() => ({}))

export const HorizontalScrollBarWithButton = ({
  children,
  sx = {},
  className,
  ...props
}) => {
  const theme = useTheme()
  const { root, content } =
    theme.components[`HorizontalScrollBarWithButton`]?.styleOverrides || {}

  return (
    <ScrollableTab
      sx={deepmerge(root, sx)}
      className={clsx("HorizontalScrollBarWithButton-root", className)}
    >
      <TabContentWrapper
        sx={content}
        className="HorizontalScrollBarWithButton-content"
      >
        {children}
      </TabContentWrapper>
    </ScrollableTab>
  )
}
